// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"436":"7122454b","548":"f4651c54","629":"9db612df","720":"525101c6","945":"5faa932c"}[chunkId] + ".chunk.css";
};